import { render, staticRenderFns } from "./platform-form.vue?vue&type=template&id=55933d94&"
import script from "./platform-form.vue?vue&type=script&lang=js&"
export * from "./platform-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports